export const DELETE_RULE = "DELETE_RULE";
export const SET_RULE = "SET_RULE";
export const SET_MODE = "SET_MODE";
